import { render, staticRenderFns } from "./Editions.vue?vue&type=template&id=62cfbb9d&scoped=true&"
import script from "./Editions.vue?vue&type=script&lang=js&"
export * from "./Editions.vue?vue&type=script&lang=js&"
import style0 from "./Editions.vue?vue&type=style&index=0&id=62cfbb9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cfbb9d",
  null
  
)

export default component.exports